export default {
  pageSize: 10,
  pageSizes: [10,25,30,50,100],
  widthRowNumber:80,
}; 

